import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import CookieBanner from "@/components/CookieBanner";
import ScrollToTop from "@/components/ScrollToTop";
import { DeliveryBanner } from "@/components/DeliveryInfo";
import Home from "@/pages/Home";
import Restaurant from "@/pages/Restaurant";
import Reservation from "@/pages/Reservation";
import Commander from "@/pages/Commander";
import Contact from "@/pages/Contact";
import PaymentSuccess from "@/pages/PaymentSuccess";
import AdminDashboard from "@/pages/AdminDashboard";
import KitchenView from "@/pages/KitchenView";
import MentionsLegales from "@/pages/MentionsLegales";
import CGV from "@/pages/CGV";
import PolitiqueConfidentialite from "@/pages/PolitiqueConfidentialite";
import PolitiqueCookies from "@/pages/PolitiqueCookies";

// Routes that should be displayed full-screen without the public chrome (navbar/footer/banners)
const FULLSCREEN_PATHS = ['/cuisine'];

function Layout() {
  const { pathname } = useLocation();
  const isFullscreen = FULLSCREEN_PATHS.some((p) => pathname.startsWith(p));

  if (isFullscreen) {
    return (
      <Routes>
        <Route path="/cuisine" element={<KitchenView />} />
      </Routes>
    );
  }

  return (
    <>
      <div className="fixed top-0 left-0 right-0 z-50">
        <DeliveryBanner />
        <Navbar />
      </div>
      <main className="pt-[calc(32px+80px)]">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/restaurant" element={<Restaurant />} />
          <Route path="/reservation" element={<Reservation />} />
          <Route path="/commander" element={<Commander />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/commande/success" element={<PaymentSuccess />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/dashboard-resto" element={<AdminDashboard />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route path="/cgv" element={<CGV />} />
          <Route path="/politique-confidentialite" element={<PolitiqueConfidentialite />} />
          <Route path="/politique-cookies" element={<PolitiqueCookies />} />
        </Routes>
      </main>
      <Footer />
      <CookieBanner />
    </>
  );
}

function App() {
  return (
    <div className="App min-h-screen bg-[#F5F2EA]">
      <BrowserRouter>
        <ScrollToTop />
        <Layout />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
